import { createModule } from 'saga-slice';
import { UserDetails } from '../../models/userDetailsType';
import {
  deleteUserSagaFactory,
  fetchAdminUsersSagaFactory,
  updateUserSagaFactory,
} from './sagas';
import { initialState, AdminUsersState } from './stateType';

const Slice = createModule({
  name: 'usersDetails',
  initialState,
  reducers: {
    fetchUsers: (state: AdminUsersState) => {
      state.loading = true;
      state.error = null;
    },
    fetchUsersSuccess: (state: AdminUsersState, payload: UserDetails[]) => {
      state.usersDetails = payload;
      state.loading = false;
    },
    fetchUsersError: (state: AdminUsersState, payload: Error) => {
      state.loading = false;
      state.error = payload;
    },
    updateUser: (state: AdminUsersState) => {
      state.loading = true;
    },
    updateUserSuccess: (state: AdminUsersState, payload: UserDetails) => {
      const index = state.usersDetails.findIndex(
        (user) => user.id === payload.id,
      );
      if (index > -1) state.usersDetails[index] = payload;
      state.loading = false;
    },
    updateUserError: (state: AdminUsersState, payload: Error) => {
      state.loading = false;
      state.error = payload;
    },
    deleteUser: (state: AdminUsersState) => {
      state.loading = true;
    },
    deleteUserSuccess: (state: AdminUsersState, payload: UserDetails) => {
      state.loading = false;
      state.usersDetails = state.usersDetails.filter(
        (user) => user.id !== payload.id,
      );
    },
    deleteUserError: (state: AdminUsersState, payload: Error) => {
      state.loading = false;
      state.error = payload;
    },
  },
  sagas: (actions) => ({
    [actions.fetchUsers]: fetchAdminUsersSagaFactory(actions),
    [actions.updateUser]: updateUserSagaFactory(actions),
    [actions.deleteUser]: deleteUserSagaFactory(actions),
  }),
});

export default Slice;
export const userDetailsActions = Slice.actions;
